module.exports = __webpack_public_path__ + "assets/img/11_1516_big.2f10a6cc.jpg";